import { render } from "./navComponent.vue?vue&type=template&id=07485443&scoped=true"
import script from "./navComponent.vue?vue&type=script&lang=js"
export * from "./navComponent.vue?vue&type=script&lang=js"

import "./navComponent.vue?vue&type=style&index=0&id=07485443&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07485443"]])

export default __exports__